import {
  BatchCompatibilityRequest,
  CompatibilityRequest,
  CompatibilityResponse,
  ModelAndBrand
} from 'ctp-compatibility-checker';
import { compatibilityCheckerApiCaller } from './callers';
import { postMultipart } from './callers/customFetch';
import {
  CHECK_COMPATIBILITY_BATCH,
  CHECK_COMPATIBILITY_BY_MODEL,
  CHECK_COMPATIBILITY_DDD,
  CHECK_VEHICLE_INFO_COMPATIBILITY
} from './types';

const actions = {
  async [CHECK_VEHICLE_INFO_COMPATIBILITY](_: any, payload: CompatibilityRequest) {
    return compatibilityCheckerApiCaller
      .checkVehicleCompatibility(payload)
      .then((response: CompatibilityResponse) => response)
      .catch((error) => {
        throw error.json();
      });
  },

  /**
   * The generated `ctp-compatibility-checker` client exposes a
   * `checkDDDCompatibility` method, but it sends the file as
   * `application/x-www-form-urlencoded` instead of `multipart/form-data`,
   * so it cannot be used for a real file upload (see
   * API_DDD_COMPATIBILITY.MD at the repo root). Uses the shared
   * `postMultipart` helper instead, which keeps the same auth/error
   * handling behaviour as the generated client.
   */
  async [CHECK_COMPATIBILITY_DDD](_: any, payload: File) {
    const formData = new FormData();
    formData.append('dddFile', payload);

    return postMultipart<CompatibilityResponse[]>(
      '/api/compatibility-checker/check-compatibility-ddd',
      formData
    );
  },

  async [CHECK_COMPATIBILITY_BY_MODEL](_: any, payload: ModelAndBrand) {
    return compatibilityCheckerApiCaller
      .checkModelCompatibility(payload)
      .then((response: CompatibilityResponse) => response)
      .catch((error) => {
        throw error.json();
      });
  },

  async [CHECK_COMPATIBILITY_BATCH](_: any, payload: BatchCompatibilityRequest) {
    return compatibilityCheckerApiCaller
      .checkBatchCompatibility(payload)
      .then((response: CompatibilityResponse[]) => response)
      .catch((error) => {
        throw error.json();
      });
  }
};

export default actions;
